import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const AgeBlockedScreen = () => {
  const { t } = useTranslation();
  return (
    <div className="fixed inset-0 z-[200] bg-background flex items-center justify-center px-4">
      <motion.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="w-full max-w-sm text-center space-y-6"
      >
        <div className="w-20 h-20 rounded-3xl bg-muted flex items-center justify-center mx-auto">
          <span className="text-5xl">🚫</span>
        </div>
        <h1 className="font-display text-2xl font-bold text-foreground">
          {t("ageBlocked.title")}
        </h1>
        <p className="text-sm text-muted-foreground leading-relaxed max-w-xs mx-auto">
          {t("ageBlocked.message")}
        </p>
      </motion.div>
    </div>
  );
};

export default AgeBlockedScreen;
